import { Brand, createBranded } from '@deltasierra/type-utilities';
import { HasId } from '../common';
import { UserId } from '../user/User';
import { PrintProviderSKUId } from './PrintProviderSKU';
import { PrintProviderStatsId } from './PrintProviderStats';

export type PrintProviderOrderId = Brand<number, 'PrintProviderOrderId'>;
export const PrintProviderOrderId = createBranded<PrintProviderOrderId>();

export interface PrintProviderOrder extends HasId<PrintProviderOrderId> {
    createdAt: Date;
    createdById: UserId;

    orderNumber: string;
    priceAmount: string;
    priceAmountInCents: number;
    priceCurrency: string;
    sku: string;
    skuName: string;
    printProviderSKUId: PrintProviderSKUId;
    printProviderStatsId: PrintProviderStatsId;
}
